import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import styles from './index.css';

import Header from '../../components/header';
import HeaderBox from './headerBox';
import Subhead from './subhead';
import Footer from './footer';

import Content from './content';
import ChannelLink from './channelLink';

import Ad from '@ifeng-fe/ui_pc_ad';
import NoSSR from 'react-no-ssr';

class Layout extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
    }

    render() {
        const {
            nav,
            footer,
            search,
            navData,
            channel,
            columnId,
            channelLink,
            videoStream,
            bannertopAd,
            banner01Ad,
            banner02Ad,
            banner03Ad,
            bannerbottomAd,
        } = this.props.content;

        const contentAd = {
            banner01Ad,
            banner02Ad,
            banner03Ad,
        };

        return (
            <Fragment>
                <Header content={nav} />
                {/* 顶部广告 */}
                <div className={styles.topAd}>
                    <Ad content={bannertopAd} />
                </div>
                <HeaderBox search={search} />
                <Subhead content={navData} channel={channel} columnId={columnId} />
                <NoSSR>
                    <Content content={videoStream} ad={contentAd} columnId={columnId} />
                </NoSSR>
                <div className={styles.footerAd}>
                    <Ad content={bannerbottomAd} />
                </div>
                <NoSSR>
                    <Chip id="40113" type="static" title="友情链接" groupName="底部" content={channelLink}>
                        <ChannelLink />
                    </Chip>
                </NoSSR>
                <Footer content={footer} />

                <ChipEdit transform={transform} />
            </Fragment>
        );
    }
}

export default Layout;
